const UrlsGenerater = (query, url) => {
    handelSort(query);
    handleStorageQuery(query);
    return buildUrl(query, url);
};

export default UrlsGenerater;

const hasValue = (value) => [undefined, null, -1, ""].includes(value) === false;

const buildUrl = (query, url) => {
    url += "?";
    Object.entries(query).map(([key, value]) => hasValue(value) && (url += `${key}=${value}&`));
    return url.slice(0, -1);
};

const handelSort = (query) => {
    if (query.sort) {
        let desc = query.desc ? "-" : "";
        if (query.initalSort && query.sort !== query.initalSort) {
            query.sort = `${desc}${query.sort},${desc}${query.initalSort}`;
            delete query.initalSort;
        } else query.sort = `${desc}${query.sort}`;
        delete query.desc;
    }
};

const handleStorageQuery = (query) => {
    if (query.storageQuery && query.storageQuery.query) query = { ...query, ...query.storageQuery.query };
};
